<!--  Content  -->
<div *ngIf="!isFirstLoad" class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <!--  Error Views  -->
    <app-module-error class="flex-fill" *ngIf="noMetric" [noMetric]="true"></app-module-error>
    <app-module-error class="flex-fill" *ngIf="noData && !noMetric" [noData]="true"></app-module-error>
    <div style="width:100%; height:calc(100% - 45px)" *ngIf="!noMetric && !noData">
        <div class="position-relative w-100 h-100" style="flex: 1 1 0px; min-width: 0">
            <canvas baseChart *ngIf="chartConfig"
                [type]="chartConfig.type"
                [legend]="chartConfig.options.plugins?.legend"
                [datasets]="chartConfig.data.datasets"
                [labels]="chartConfig.data.labels"
                [options]="chartConfig.options"
                [plugins]="chartConfig.plugins">
            </canvas>
        </div>
        <div class="m-2 ml-5 d-flex flex-wrap align-items-center" style="position: absolute;">
            <mat-label class="body-2 mr-3" style="font-size: 14px;" cvLocalizedText langSection="Trending" langKey="Show_Objective">Show Objective</mat-label>
            <mat-slide-toggle [(ngModel)]="showObjective" (ngModelChange)="handleShowObjective()" class="mr-2" [disabled]="!hasObjective">    </mat-slide-toggle>
        </div>
    </div>
</div>
